import React from "react";
import PropTypes from "prop-types";
import { useArena } from "core/components/ArenaProvider";
import ContentHelmet from "arena/components/ContentHelmet";
import ShortyVirtualFeed from "./ShortyVirtualFeed";

export default function Shorty({ params: { contentId } }) {
  const arena = useArena();

  return (
    <>
      <ContentHelmet arena={arena} />
      <ShortyVirtualFeed initialContentId={contentId} />
    </>
  );
}

Shorty.propTypes = {
  params: PropTypes.shape({
    contentId: PropTypes.string.isRequired,
  }),
};
